import HorizontalCarousel from './HorizontalCarousel';

export default HorizontalCarousel;
